export default __webpack_public_path__ + "static/media/anime-crying.7dd5c8e0.gif";